import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import { RectangularTextViewProps } from "./types";
import { useState } from "react";
import { css } from "styled-components/native";
import TooltipButton from "@scenes/pdp/utils/TooltipButton";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { DefaultTheme } from "styled-components/native";

const RectangularTextView = ({
  backgroundColor,
  borderColor,
  isSelected,
  item,
  numberOfLines = 0,
  onPress,
}: RectangularTextViewProps) => {
  const { typography, theme, t } = useScreenOptionsHooks();
  const [isHovered, setIsHovered] = useState(false);
  const isUnavailable = !item.enabled;

  const ToolTipComponent = () => {
    return (
      <>
        <VDBText
          color={theme["core-01"]}
          type={typography["Minor-R"]}
          textAlign={"left"}
        >
          {t(
            "productDetailPage.jewelryConfigurator.disabledItemTooltip.text",
            "This option is not visible for the current selection."
          )}
        </VDBText>
      </>
    );
  };

  const renderComponent = () => {
    return (
      <Container
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        onHoverIn={() => {
          if (!isUnavailable && theme.isLargeScreen) {
            setIsHovered(true);
          }
        }}
        onHoverOut={() => {
          if (theme.isLargeScreen) {
            setIsHovered(false);
          }
        }}
        isHovered={isHovered}
        isUnavailable={isUnavailable}
        onPress={() => onPress(item)}
      >
        <TextContainer>
          <VDBText
            color={
              theme[
                isSelected
                  ? "core-05"
                  : isUnavailable
                  ? "core-04"
                  : "option-cont"
              ]
            }
            type={typography["Body-R"]}
            textAlign={"center"}
            numberOfLines={numberOfLines}
          >
            {item?.label}
          </VDBText>
        </TextContainer>
      </Container>
    );
  };

  return (
    <>
      {isUnavailable && theme.isLargeScreen ? (
        <TooltipButton
          width={"auto"}
          children={renderComponent()}
          enableTooltip={true}
          renderComponent={ToolTipComponent()}
        />
      ) : (
        renderComponent()
      )}
    </>
  );
};

const Container = styled.Pressable<{
  backgroundColor: string;
  borderColor: string;
  isHovered: boolean;
  isUnavailable?: boolean;
}>`
  height: 32px;
  min-width: 32px;
  max-width: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isMobile ? 311 : 408}px;
  background-color: ${({
    backgroundColor,
    isHovered,
    theme,
    isUnavailable,
  }: {
    backgroundColor: string;
    isHovered: boolean;
    theme: DefaultTheme;
    isUnavailable: boolean;
  }) =>
    isHovered
      ? theme["option-bg-static"]
      : isUnavailable
      ? theme["core-02"]
      : backgroundColor};
  border-color: ${({
    borderColor,
    theme,
    isHovered,
    isUnavailable,
  }: {
    borderColor: string;
    theme: DefaultTheme;
    isHovered: boolean;
    isUnavailable: boolean;
  }) => (isHovered || isUnavailable ? theme["core-04"] : borderColor)};
  border-width: 1px;
  align-items: center;
  justify-content: center;
  border-radius: ${SpaceType.Basic}px;
  ${({ isUnavailable }: { isUnavailable: boolean }) =>
    isUnavailable &&
    css`
      border-style: dashed;
    `}
`;

const TextContainer = styled.View`
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  justify-content: center;
  height: 20px;
  max-width: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isMobile ? 311 : 408}px;
`;

export default RectangularTextView;
